import { AffiliateResetPasswordPage } from './affiliate-reset-password.component';
import { connect } from 'react-redux';
import { affiliateResetPassword } from './../../api/affiliate/affiliateAction';

const mapDispatchToProps = {
    affiliateResetPassword
};

const mapStateToProps = state => ({
    isLoading: state.affiliatePage.isLoading,
    isReset: state.affiliatePage.isReset
});

export const AffiliateResetPasswordContainer = connect(mapStateToProps, mapDispatchToProps)(AffiliateResetPasswordPage);
